// extracted by mini-css-extract-plugin
export default {"selectedTypeContent":"CustomInsightCreationModal_selectedTypeContent__U7WHp","customInsightCreationModal":"CustomInsightCreationModal_customInsightCreationModal__SgkQQ"};